import { memo } from 'react'
import { appEnvironment, getEnv } from 'utils/env'
import { styled } from '@material-ui/core/styles'
import { version } from '../package.json'

const Container = styled('div')({
  textAlign: 'center',
  color: '#afafaf',
  fontSize: '0.75rem',
  marginTop: '1rem'
})

export const getVersion = () => {
  const gitInfo = getEnv('REACT_APP_GIT_INFO') || 'N/A'
  const prefixedVersion = `v${version}`

  if (appEnvironment === 'production') {
    return prefixedVersion
  }

  return `${prefixedVersion} - ${gitInfo} - ${appEnvironment}`
}

const VersionDisplay = () => <Container>{getVersion()}</Container>

export default memo(VersionDisplay)
